import { IAppState } from '../../../AppModulesWrapper';

export const selectIsArchived = (state: IAppState): boolean => {
  return !!state.servicePickerWidget.offer.flags?.isArchived;
};
